export default {
  open: 'hb-modal:open',
  close: 'hb-modal:close'
};
